// --- START OF FILE systemStatus.js ---

// Chave unica de bloqueio do painel administrativo.
//   true  -> painel bloqueado: sessoes salvas sao derrubadas e o login exibe o modal
//   false -> operacao normal
//
// IMPORTANTE: existe um bloqueio equivalente no backend, na secao "AdminAccess"
// do appsettings.json. Para religar o sistema, os dois precisam voltar para false.
export const ADMIN_BLOQUEADO = false;

export const BLOQUEIO_TITULO = "SISTEMA ADMINISTRATIVO FORA DO AR";

export const BLOQUEIO_MENSAGEM =
  "O acesso ao painel administrativo foi temporariamente suspenso. Entre em contato com o responsavel pelo sistema para regularizar o acesso.";

// Remove qualquer sessao de admin guardada no navegador.
export const limparSessaoAdmin = () => {
  localStorage.removeItem("adminAccessToken");
  localStorage.removeItem("adminRefreshToken");
  localStorage.removeItem("admin-email-golden");
};
